const setActiveTab = (tab, refsList) => {
	for (const key in refsList) {
		refsList[key].classList.add('show', 'active');
		if (key !== tab) {
			refsList[key].classList.remove('show', 'active');
		}
	}
};

export default setActiveTab;
